import React from "react";
import { screenNames } from "./utils/constants";
import LoginSignUpComponent from "./components/LoginSignUpComponent";
import OTPComponent from "./components/OTPComponent";
import BasicDetailComponent from "./components/BasicDetailComponent";
import ProfessionalDetailComponent from "./components/BasicDetailComponent/ProfessionalDetailComponent";
import FAComponent from "./components/FAComponent";

// import WorkExperienceComponent from "./components/WorkExperienceComponent";
// import LocationComponent from "./components/LocationComponent";
// import SuccessComponent from "./components/SuccessComponent";

const renderMap = ({ goNext, goBack, state }) => {
  return {
    [screenNames.LoginSignUpComponent]: (
      <LoginSignUpComponent goNext={goNext} goBack={goBack} state={state} />
    ),
    [screenNames.OTPComponent]: (
      <OTPComponent goNext={goNext} goBack={goBack} state={state} />
    ),
    [screenNames.BasicDetailComponent]: (
      <BasicDetailComponent goNext={goNext} goBack={goBack} state={state} />
    ),
    [screenNames.ProfessionalDetailComponent]: (
      <ProfessionalDetailComponent
        goNext={goNext}
        goBack={goBack}
        state={state}
      />
    ),
    [screenNames.FAComponent]: (
      <FAComponent goNext={goNext} goBack={goBack} state={state} />
    )
    // [screenNames.WorkExperienceComponent]: (
    //   <WorkExperienceComponent goNext={goNext} goBack={goBack} state={state} />
    // ),
    // [screenNames.LocationComponent]: (
    //   <LocationComponent goNext={goNext} goBack={goBack} state={state} />
    // ),
    // [screenNames.SuccessComponent]: (
    //   <SuccessComponent goNext={goNext} goBack={goBack} state={state} />
    // )
  };
};

export default renderMap;
